import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OrganizationEntityDto } from 'app/@types/dto/organization-entity-dto.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-select-measure',
    templateUrl: './select-measure.component.html',
    styleUrls: ['./select-measure.component.scss'],
})
export class SelectMeasureComponent {
    form: FormGroup;
    public availableYears: number[];
    public entities: OrganizationEntityDto[];

    constructor(private fb: FormBuilder, private ref: DynamicDialogRef, public config: DynamicDialogConfig) {}

    ngOnInit(): void {
        this.form = this.fb.group({
            year: [this.config.data.questionnaire.firstYearMeasured, Validators.required],
            entity: [this.config.data.activeEntity, Validators.required],
        });
        this.availableYears = [...this.config.data.availableYears];
        this.availableYears.sort();
        this.entities = [...this.config.data.entities];
    }

    save(): void {
        this.ref.close(this.form.value);
    }

    close(): void {
        this.ref.close({ year: undefined });
    }
}
